/**
 * world module entry (owner: env-builder). Content scenes extend `WorldScene`; other modules use only
 * the pure helpers exported here. See docs/core-change-requests/env-builder.md for integration notes.
 */
export { WorldScene, DEFAULT_WORLD_CONFIG, type WorldSceneConfig, type WorldActorConfig } from './WorldScene';
export {
  WeatherDirector, WEATHER_ORDER, WEATHER_LOOKS, isWeatherState, weatherIndex, lerpColor, lerpLook, easeInOut,
  type WeatherLook, type WeatherEmission,
} from './WeatherDirector';
export { NpcScheduleRunner, type ScheduledActor } from './NpcScheduler';
export { resolveSpawn, sceneKeyForExit, fallbackMap, cameraBoundsFor, beginWeather, type SpawnPoint, type CameraBounds, type WeatherFollower } from './sceneHelpers';
export { depthForFeet, applyWorldDepth, sortByFeet, type DepthSortable } from './depth';
export { clampScroll, followScroll, panAt, shakeOffset, easeInOutCubic, type Vec2 } from './cameraMath';
export { stepMove, bodyBlocked, facingFrom, DEFAULT_BODY, type MoveInput, type FeetBody, type BlockedFn } from './movement';
export { DevPlayerMover, DevFollowerTrail } from './DevPlayerMover';
export { GreyMapScene, registerShowcase, WORLD_SHOWCASE_KEY, WEATHER_LABEL, FONT_FAMILY, type WorldDebugHandle } from './GreyMapScene';
export { buildDevMap, tileSolid, DEV_MAP_ID, DEV_TILESET_KEY, DEV_TILES, DEV_RECTS, DEV_MAP_W, DEV_MAP_H } from './dev/devMap';
export { ensureDevTileset, drawDevMapLayers, type DevMapVisuals } from './dev/devTextures';
